import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// native components
import ClientServicesPhone4644, { clientServicesPhoneNumberLinkUrl } from '../../../../components/clientServicesPhone4644/clientServicesPhone4644';

export default () => (
  <SectionContainer id='customer-privacy-notice-nmis-questions-and-info'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          variant='h3'>
          To limit our sharing
        </Typography>
        <Typography nextElement='typography'>
          Call{' '}
          <Link
            id='customer-privacy-notice-nmis-first-phone-number-link'
            variant='primaryDeemphasize'
            linkUrl={clientServicesPhoneNumberLinkUrl}>
            <ClientServicesPhone4644 />
          </Link>
          {' '}and when prompted say limit sharing.
        </Typography>
        <Typography nextElement='typography'>
          <strong>Please note:</strong> If you are a new customer, we can begin sharing your information 30 days from the date we sent this notice. When you are no longer our customer, we continue to share your information as described in this notice. However, you can contact us at any time to limit our sharing.
        </Typography>
        <Typography
          nextElement='typography'
          component='h3'>
          Questions
        </Typography>
        <Typography nextElement='typography'>
          Call{' '}
          <Link
            id='customer-privacy-notice-nmis-second-phone-number-link'
            variant='primaryDeemphasize'
            linkUrl={clientServicesPhoneNumberLinkUrl}>
            <ClientServicesPhone4644 />
          </Link>
          {' '}and when prompted say privacy or go to{' '}
          <Link
            id='customer-privacy-notice-nmis-nm-site-link'
            variant='primaryDeemphasize'
            linkUrl='/'>
            NorthwesternMutual.com
          </Link>.
        </Typography>
        <Typography
          nextElement='typography'
          component='h3'>
          Who we are
        </Typography>
        <Typography
          nextElement='typography'>
          <strong>Who is providing this notice&#63;</strong>
        </Typography>
        <Typography
          nextElement='typography'>
          This privacy notice is provided by Northwestern Mutual Investment Services, LLC and Northwestern Mutual Wealth Management Company.
        </Typography>
        <Typography
          nextElement='typography'
          component='h3'>
          What we do
        </Typography>
        <Typography
          nextElement='typography'>
          <strong>How do NMIS and NMWMC protect my personal information&#63;</strong>
        </Typography>
        <Typography
          nextElement='typography'>
          To protect your personal information from unauthorized access and use, we use technical, administrative, and physical controls that comply with federal and state law.
        </Typography>
        <Typography nextElement='typography'>
          <strong>How do NMIS and NMWMC collect my personal information&#63;</strong>
        </Typography>
        <Typography nextElement='typography'>
          We collect personal information, for example, when you or your authorized representative:
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: 'interact with our websites or mobile application.' },
            { bulletText: 'seek an advisor.' },
            { bulletText: 'engage in factfinding, planning or recommendations.' },
            { bulletText: 'apply for a product or service or open an account.' },
            { bulletText: 'aggregate your accounts.' },
            { bulletText: 'communicate and transact with us, including members of our Field Sales Force.' },
          ]}
        />
        <Typography nextElement='typography'>
          We also collect your personal information from others, such as from affiliates, service providers, individual referrals, or other companies.
        </Typography>
        <Typography nextElement='typography'>
          <strong>
            Why can&#39;t I limit all sharing&#63;
          </strong>
        </Typography>
        <Typography nextElement='typography'>
          Federal law gives you the right to limit only:
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>sharing for affiliates&#39; everyday business purposes&#8212;information about your creditworthiness.</> },
            { bulletText: 'affiliates from using your information to market to you.' },
            { bulletText: 'sharing for nonaffiliates to market to you.' },
          ]}
        />
        <Typography nextElement='typography'>
          State laws and individual companies may give you additional rights to limit sharing. See below for more on your rights under state law.
        </Typography>
        <Typography nextElement='typography'>
          <strong>What happens when I limit sharing for an account I hold jointly with someone else&#63;</strong>
        </Typography>
        <Typography nextElement='typography'>
          Your choices will apply to everyone on your account.
        </Typography>
        <Typography
          nextElement='typography'
          component='h3'>
          Definitions
        </Typography>
        <Typography nextElement='typography'>
          <strong>Affiliates</strong>
        </Typography>
        <Typography nextElement='typography'>
          Our Sharing Affiliates include The Northwestern Mutual Life Insurance Company, Northwestern Long Term Care Insurance Company, and, for purposes of privacy and information sharing, the network offices of our Field Sales Force. Our Field Sales Force is made up of independent contractors, including financial representatives and their staff, all of whom sell our products and services.
        </Typography>
        <Typography nextElement='typography'>
          <strong>Nonaffiliates</strong>
        </Typography>
        <Typography nextElement='typography'>
          Companies not related by common ownership or control. They can be financial and nonfinancial companies. For example, we use other companies to perform business functions for us or as requested or authorized by you.
        </Typography>
        <Typography nextElement='typography'>
          <strong>Joint Marketing</strong>
        </Typography>
        <Typography nextElement='typography'>
          A formal agreement between nonaffiliated financial companies that together market financial products or services to you. <em>Neither NMIS nor NMWMC jointly market.</em>
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Other important information
        </Typography>
        <Typography nextElement='typography'>
          &#42;With your authorization, information relating to creditworthiness that affects your ability to purchase one of our products or services may be shared.
        </Typography>
        <Typography nextElement='typography'>
          &#42;&#42;If you need assistance revoking your authorization, please contact the Privacy Office at{' '}
        </Typography>
        <Link
          id='customer-privacy-notice-revoking-your-authorization-email-link'
          linkUrl='mailto:DL-privacy@northwesternmutual.com'
          variant='primaryDeemphasize'
          isOutgoingLink>
          DL&#8211;privacy&#64;northwesternmutual.com
        </Link>
        {' '}or{' '}
        <Link
          id='customer-privacy-notice-phone-number-link'
          variant='primaryDeemphasize'
          linkUrl='tel:4146656042'>
          414&#45;665&#45;6042
        </Link>.
        <Typography nextElement='typography'>
          We honor written, verifiable requests, asking to learn the nature and substance of personal information recorded in our files that is reasonably locatable and retrievable, to see or obtain a copy of that information, and to learn the identity of those to whom we have disclosed the information. We do so voluntarily and when required by law. If you believe that any of our records are inaccurate, you may notify us in writing of any corrections, amendments, or deletions that you believe should be made, and we will review and respond to that request. You may exercise these rights or obtain additional information by submitting a request at{' '}
          <Link
            id='nmis-customer-privacy-notice-nmis-submit-consumer-rights-request-link'
            variant='primaryDeemphasize'
            linkUrl='https://ConsumerRightsRequest.nm.com/'
            isOutgoingLink>
            https:&#47;&#47;ConsumerRightsRequest.nm.com&#47;
          </Link>, or by writing to: Privacy Office, NMIS&#47;NMWMC, 720 E. Wisconsin Ave., Milwaukee, WI 53202. <strong>For our customers residing in VT,</strong> we will not disclose information about your creditworthiness to our affiliates other than as permitted by Vermont law, unless you authorize us to make those disclosures.
        </Typography>
        <Typography nextElement='typography'>
          For additional information about our privacy related insurance practices, please view our Supplemental Notice of Insurance Information Practices on NorthwesternMutual.com.
        </Typography>
        <Typography nextElement='typography'>
          <strong>For NV residents,</strong> we are providing this notice pursuant to state law. If you do not want to receive unsolicited calls from us, you have the right to request that your number be placed on our internal do not call list. To exercise this right or if you have questions, please contact us at{' '}
          <Link
            id='customer-privacy-notice-nmis-do-not-call-list-phone-number-link'
            variant='primaryDeemphasize'
            linkUrl={clientServicesPhoneNumberLinkUrl}>
            <ClientServicesPhone4644 />
          </Link>
          , via mail at Do Not Call Compliance, The Northwestern Mutual Life Insurance Company, 720 East Wisconsin Ave., Milwaukee, WI 53202 or via{' '}
          <Link
            id='customer-privacy-notice-nmis-do-not-call-email-link'
            linkUrl='mailto:donotcallform@northwesternmutual.com'
            variant='primaryDeemphasize'
            isOutgoingLink>
            email at DoNotCallForm&#64;NorthwesternMutual.com
          </Link>
          . You may also contact the NV Attorney General for information on this law at{' '}
          <Link
            id='customer-privacy-notice-nmis-nv-attorney-general-phone-number-link'
            variant='primaryDeemphasize'
            linkUrl='tel:7024863132'>
            702&#45;486&#45;3132
          </Link>
          , via mail at 100 North Carson Street, Carson City, NV 89701, or via{' '}
          <Link
            id='customer-privacy-notice-ag-info-email-link'
            variant='primaryDeemphasize'
            linkUrl='mailto:AgInfo@ag.nv.gov'
            isOutgoingLink>
            email at AgInfo&#64;ag.nv.gov
          </Link>.
        </Typography>
        <Typography disableBottomPadding>
          92&#45;0237 (0102) (REV0225)
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
